import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import styles from './lineage-toggle.module.css';

type PublicRetrievalToggleProps = {
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
	disabled?: boolean;
};

export const PUBLIC_RETRIEVAL_TOGGLE_LABEL =
	'Permitir descarga pública del documento firmado';

export const PublicRetrievalToggle = ({
	checked,
	onCheckedChange,
	disabled,
}: PublicRetrievalToggleProps) => (
	<div className={styles.nested} data-testid="public-retrieval-toggle">
		<div className={styles.option}>
			<Checkbox
				id="public-retrieval"
				checked={checked}
				disabled={disabled}
				onCheckedChange={(value) => onCheckedChange(value === true)}
			/>
			<Label htmlFor="public-retrieval" className={styles.label}>
				{PUBLIC_RETRIEVAL_TOGGLE_LABEL}
			</Label>
		</div>
		<p className={styles.description}>
			Cualquier persona que tenga el código QR o el enlace impreso podrá
			descargar el documento firmado, sin iniciar sesión. Puedes retirar la
			descarga más adelante desde Mis documentos, pero no volver a
			habilitarla.
		</p>
	</div>
);
